import React, { useEffect, useRef, useState } from "react";
import "./MoreAboutUs.css";
import { Link } from "react-router-dom";

export default function MoreAboutUs() {
  const IMG = "/abth.jpg";
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="maw-section" ref={sectionRef}>
      <div className="maw-container">
        <div className="maw-grid">
          {/* Left side - Image */}
          <div className={`maw-image-wrapper ${isVisible ? "is-visible" : ""}`}>
            <div className="maw-image-container">
              <img
                src={IMG}
                alt="Luxury wellness spa treatment"
                className="maw-image"
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div className={`maw-content ${isVisible ? "is-visible" : ""}`}>
            <h2 className="maw-title">
              <span className="maw-title-line">Relaxation and Relief </span>
              <span className="maw-title-line maw-title-accent">Through Therapeutic Massage</span>
            </h2>

            <p className="maw-description">
              Step into a space designed for comfort and care, where your body and mind can truly relax. At A Peaceful Retreat, I provide professional massage services and therapeutic massage treatments tailored to ease tension, reduce stress, and support overall well-being. Each massage is delivered with attention to detail, creating a calming experience focused on relaxation, recovery, and lasting results.
            </p>

            <div className="maw-divider" />

            <div className="maw-features">
              <div className="maw-feature">
                <span className="maw-feature-icon">✦</span>
                <span className="maw-feature-text">Professional Massage Services</span>
              </div>
              <div className="maw-feature">
                <span className="maw-feature-icon">✦</span>
                <span className="maw-feature-text">Skilled and Experienced Therapist</span>
              </div>
              <div className="maw-feature">
                <span className="maw-feature-icon">✦</span>
                <span className="maw-feature-text">Calming, Comfortable Setting</span>
              </div>
            </div>
            <Link to="/about" className="maw-button">
              <span className="maw-button-text">Learn More About Me</span>
              <span className="maw-button-arrow">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}